import React from 'react';

import StepperDrawerHeader from '../../../common/components/StepperDrawerHeader/StepperDrawerHeader';
import { useUploadTagSheetContext } from '../../UploadTagSheetStepperProvider/UploadTagSheetStepperProvider';

type Props = {
  onNext?: () => void;
  title: React.ReactNode;
  confirmButtonDisabled?: boolean;
  confirmText?: string;
  loading?: boolean;
  tooltipText?: string;
  hideCancel?: boolean;
};

const UploadTagSheetHeader = ({
  title,
  onNext,
  confirmButtonDisabled = false,
  confirmText = 'Next',
  tooltipText,
  loading,
  hideCancel = false,
}: Props): React.JSX.Element => {
  const { onCloseStepper, step, goToNextStep, goToPrevStep } = useUploadTagSheetContext();

  return (
    <StepperDrawerHeader
      title={title}
      step={step}
      confirmButtonDisabled={confirmButtonDisabled}
      onNext={onNext ?? goToNextStep}
      onCancel={onCloseStepper}
      onBack={goToPrevStep}
      confirmText={confirmText}
      tooltipText={tooltipText}
      loading={loading}
      hideCancel={hideCancel}
    />
  );
};

export default UploadTagSheetHeader;
